import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as InsuranceDocActions from '../_actions/insuranceDoc';
import { InsuranceDoc } from '../_models/insuranceDoc';

export interface InsuranceDocState extends EntityState<InsuranceDoc> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<InsuranceDoc> = createEntityAdapter<InsuranceDoc>();

const initialState: InsuranceDocState = adapter.getInitialState({
  loading: false,
  error: null,
});

const insuranceDocReducer = createReducer(
  initialState,

  on(InsuranceDocActions.loadInsuranceDocs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(InsuranceDocActions.loadInsuranceDocsSuccess, (state, { insuranceDocs }) =>
    adapter.setAll(insuranceDocs, { ...state, loading: false })
  ),

  on(InsuranceDocActions.loadInsuranceDocsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(InsuranceDocActions.addInsuranceDocSuccess, (state, { insuranceDoc }) =>
    adapter.addOne(insuranceDoc, state)
  ),

  on(InsuranceDocActions.updateInsuranceDocSuccess, (state, { insuranceDoc }) =>
    adapter.upsertOne(insuranceDoc, state)
  ),

  on(InsuranceDocActions.deleteInsuranceDocSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    InsuranceDocActions.addInsuranceDocFailure,
    InsuranceDocActions.updateInsuranceDocFailure,
    InsuranceDocActions.deleteInsuranceDocFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: InsuranceDocState | undefined, action: Action) {
  return insuranceDocReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
